export default {
      id: "star-open-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#star-open",
      toString: function () {
        return this.url;
      }
    }